export default __webpack_public_path__ + "static/media/480_store03-es-web.59ce73f4.png";